import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { ExhibitionuserUpdate, ExhibitionfetchUser } from '../../features/dashboard/ExhibitionManagmentSlice';
import Header from './Header';
import Broadcast from './Broadcast';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';

function EditExhibitions () {
    const {id} = useParams()
    const userName = useRef();
    const mobile = useRef();
    const password = useRef()
    const city = useRef()
    
    const [FlagStatus, setFlag] = useState(false)
    const flag = useRef(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let {
        Exhibitionperson,
        Exhibitionsuccess,
        Exhibitionstatus,
        Exhibitionloading,
        Exhibitionmessage,
        ExhibitionerrorName,
        ExhibitionerrorMobile,
        ExhibitionerrorCity,
        ExhibitionerrorFlag,
        ExhibitionerrorPassword
    } = useSelector(state => state.ExhibitionManagment)

    const userUdateHandler = (event) => {
        event.preventDefault();
        const data = {
            'id': id,
            'name': userName.current.value,
            'mobile': mobile.current.value,
            'password': password.current.value,
            'city': city.current.value,
            'flag': FlagStatus == true ? '1' : null,
        }
        dispatch(ExhibitionuserUpdate(data));
        
    }
    const flagHandler = () => {

    }
    const goToUserIndex = () => {
        navigate('/dashboard/exhibitions', { replace: true })
    }



    useEffect(() => {
        ExhibitionerrorName = ''
        ExhibitionerrorMobile = ''
        ExhibitionerrorFlag = ''
        ExhibitionerrorPassword = ''
        dispatch(ExhibitionfetchUser(id))
        return () => {
            Exhibitionperson = []
            ExhibitionerrorName = ''
            ExhibitionerrorMobile = ''
            ExhibitionerrorFlag = ''
            ExhibitionerrorPassword = ''
        }
    },[])
    useEffect(() => {
        if(Exhibitionsuccess === true){
            setFlag(Exhibitionperson.status == '1' ? true : false);
        }
    },[Exhibitionperson])

    useEffect(() => {
        if(Exhibitionsuccess === true && Exhibitionstatus === true && Exhibitionloading === false && Exhibitionmessage != "") {
            toast.success(Exhibitionmessage,{
                position: "top-center",
                autoClose: 1200,
              })
              Exhibitionmessage = ''
        }

        if(Exhibitionsuccess === false && Exhibitionstatus === false && Exhibitionloading === false && Exhibitionmessage != "") {
            toast.error(Exhibitionmessage,{
                position: "top-center",
                autoClose: 1200,
              })
              Exhibitionmessage = ''
        }
    },[Exhibitionloading,Exhibitionsuccess, Exhibitionmessage])

    return (
        <>
        { Exhibitionloading ? (<Loading />) : null}
        <Broadcast title={'ویرایش نمایشگاه'} />
        <form className="text-end  ">
        <div className='row rahpardaznet-cart my-5 print-position'>
                <div className=" row col-12">
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                            نام نمایشگاه
                            </label>
                                <input
                                    tabIndex="1" 
                                    type="text"
                                    defaultValue={Exhibitionperson.name} 
                                    ref={userName}
                                    className="form-control shadow-none" 
                                    id="staticName" 
                                    autoFocus
                                />
                                {
                                    (ExhibitionerrorName) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{ ExhibitionerrorName }</small>
                                    </span>
                                ):''}
                            </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                             شهر
                            </label>
                                <input
                                    tabIndex="1" 
                                    type="text"
                                    defaultValue={Exhibitionperson.city} 
                                    ref={city}
                                    className="form-control shadow-none" 
                                    id="staticName" 
                                    autoFocus
                                />
                                {
                                    (ExhibitionerrorCity) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{ ExhibitionerrorCity }</small>
                                    </span>
                                ):''}
                            </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticMobile" className="fw-bold text-end form-label px-1">
                            موبایل
                            </label>
                            <input
                                tabIndex="2" 
                                type="text"
                                defaultValue={Exhibitionperson.mobile}
                                ref={mobile}
                                className="form-control shadow-none text-left ltr" 
                                id="staticEmail" 
                            />
                            {
                                (ExhibitionerrorMobile) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ ExhibitionerrorMobile }</small>
                                </span>
                            ):''}
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticPassword" className="fw-bold text-end form-label px-1">
                            گذرواژه
                            </label>
                            <input
                                autoComplete='new-password'
                                tabIndex="3" 
                                type="password"
                                ref={password}
                                className="form-control shadow-none" 
                                id="staticPassword" 
                                placeholder="در صورت تغیر گذرواژه جدید را وارد کنید" 
                            />
                            {
                                (ExhibitionerrorPassword) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ ExhibitionerrorPassword }</small>
                                </span>
                            ):''}
                        </div>
                    </div> 
                    <div className="col-12 p-4 d-flex flex-reverse">
                        <div className='form-check form-switch form-check-reverse'>
                           
                            <input 
                                tabIndex='4'
                                name='flag'
                                type="checkbox"
                                checked={FlagStatus === true ? 'checked' : false}
                                className="form-check-input" 
                                role="switch" 
                                onChange={(e) => setFlag(e.target.checked)} 

                            /> 
                            {
                                (FlagStatus) ? (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-success'>فعال</strong>
                                    </label>
                                ) : (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-danger'>غیرفعال</strong>
                                </label>
                                )
                            }
                           
                           
                            
                            {
                                (ExhibitionerrorFlag) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ ExhibitionerrorFlag }</small>
                                </span>
                            ):''}                                        
                        </div>
                    </div>  
                    
                    
                </div>
            </div>
        </form>
        <div className="row p-0">
                        <div className='col-12 p-0'>
                        <Button
                            tab='2'
                            title='برگشت به صفحه نمایشگاه ها'
                            design="rahpardaznet-button outline"
                            event={goToUserIndex}
                        />
                        <Button
                            tab='1'
                            title='ویرایش نمایشگاه'
                            design="rahpardaznet-button"
                            event={userUdateHandler}
                        />
                        </div>
                    </div>
        </>
    )
}

export default EditExhibitions;